import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  RecommendationPanelQuery,
  RecommendedItemsResponseType,
} from 'models-recommendation';

import { SUGGEST_API_TOKEN } from './tokens';

@Injectable()
export class SuggestService {
  private readonly api = inject(SUGGEST_API_TOKEN);
  private readonly http = inject(HttpClient);

  public suggest<T extends object, U>(payload: RecommendationPanelQuery<T>) {
    return this.http.post<RecommendedItemsResponseType<U>>(
      `${this.api}`,
      payload,
    );
  }
}
